import { UserRole } from '@eppendorf/vnls-user-tenant-utils';
import { t } from 'i18next';

export const roleDisplayNameMap: Record<UserRole, string> = {
  LAB_ADMIN: t('userManagement.roles.labAdmin'),
  LAB_MEMBER: t('userManagement.roles.labMember'),
  BILLING_USER: t('userManagement.roles.billingUser'),
};
